import React, { Component } from 'react';
import Parse from 'parse';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { GridRow, FullWidthWrapper, SecondaryButton, NoticeText, MaxContentWidthWrapper, MaxContentWidthContainer, Text, SectionHeading, TextLink, withColor, TextField } from '../marketing/MarketingStyles';
import Logo from '../../images/logo.png'
import { Facebook, LinkedIn, Instagram, Youtube } from '../../images/icons/Icons';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import config from 'react-global-configuration';

import { trackEvent } from "../../utils/eventTracking"

@inject('utilStore', 'translationStore')
@observer
class MarketingFooter extends Component {

  constructor( props ) {
    super(props)

    this.state = {
      newsletterState: 0, // 0 ... idle, 1 ... loading, 2 ... success
    }
  }

  subscribeToNewsletter = (e) => {
    e.preventDefault();
    const data = e.target

    if(!data.email.value) return

    trackEvent( 'Footer - Newsletter Signup', 'Newsletter', 'Submit Form' )

    this.setState({ newsletterState: 1 })
    Parse.Cloud.run('appendMailchimp', {
      listId: '80bbfa24a3',
      email: data.email.value,
      merge_fields: {}
    }).then(res => {
      this.setState({ newsletterState: 2 })
    }).catch(err => {
      this.setState({ newsletterState: 0 })
    })
  }

  render() {

    const { social_links, golf_course_page } = this.props.utilStore.util
    const { newsletterState } = this.state

    const isHome = this.props.history.location.pathname === "/"

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <Footer>
        <FooterTop>
          <FooterTopContent>
            <FullWidthWrapper>
              <WhiteSectionHeading>
                
                { text('marketing_footer_business')} <br />
                { text('marketing_footer_golf')} <br />
                { text('marketing_footer_network')}
              </WhiteSectionHeading>
              <WhiteText>
                { text('marketing_footer_text')}
              </WhiteText>
            </FullWidthWrapper>
            <CenteredContentWrapper>
              <CenteredContent>
                <WhiteSectionHeading>{ text('contact')}</WhiteSectionHeading>
                <WhiteTextLink onClick={ e => { e.preventDefault(); window.open("mailto:t.schnoell[at]the-loge.com".replace("[at]", "@"), "_blank") } }>t.schnoell [at] the-loge.com</WhiteTextLink>
                <WhiteTextLink href="tel:+436769444481">+43 676 94 44 481</WhiteTextLink>
                <WhiteSectionHeading>{ text('marketing_social_media')}</WhiteSectionHeading>
                <WhiteTextLink target="_blank" href={ social_links && social_links.facebook }><Facebook />Facebook</WhiteTextLink><br />
                <WhiteTextLink target="_blank" href={ social_links && social_links.linkedin }><LinkedIn />LinkedIn</WhiteTextLink>
                <WhiteTextLink target="_blank" href={ social_links && social_links.instagram }><Instagram />Instagram</WhiteTextLink>
                <WhiteTextLink target="_blank" href={ social_links && social_links.youtube }><Youtube style={{transform: "scale(1.5) translateY(10%)"}}/>Youtube</WhiteTextLink>
              </CenteredContent>
            </CenteredContentWrapper>
            <FullWidthWrapper>
              <WhiteSectionHeading>{ text('marketing_footer_newsletter')}</WhiteSectionHeading>
              <form onSubmit={ this.subscribeToNewsletter }>
                <TextField color="#FFFFFF" placeholder="Mail-Adresse" type="email" name="email"/>
                <SecondaryButton style={{ marginTop: 30 }} value="ANMELDEN"
                  value={ newsletterState === 0 ? text('marketing_footer_register') : newsletterState === 1 ? text('marketing_footer_newsletter_state1') : text('marketing_footer_newsletter_state2')}
                  disabled={ newsletterState !== 0 }
                />
                {newsletterState === 2 && <WhiteText style={{ display: 'block', textAlign: 'center', width: '100%'}}>{ text('marketing_footer_newsletter_state3') }</WhiteText>}
              </form>
              <NoticeText>{ text('marketing_footer_privacy_text') } <DataPolicyLink onClick={ () => this.props.history.push("/datenschutz")}>{ text('marketing_footer_dataprivacy') }</DataPolicyLink></NoticeText>
            </FullWidthWrapper>
          </FooterTopContent>
        </FooterTop>

        { isHome &&
          <FooterGolfCourseCTA>
            <GridRow desktop="1fr 1fr" phone="1fr">
              <FooterGolfCourseCTAImage src={`${config.get('CLOUDINARY_URL')}q_auto/w_500/${ golf_course_page && golf_course_page.footer_cta_image } `} />
              <FooterGolfCourseCTAContent>
                <WhiteSectionHeading style={{paddingTop: 0}}>{ text('marketing_footer_lower_headline') }</WhiteSectionHeading>
                <WhiteText>
                { text('marketing_footer_lower_subheadline') }
                </WhiteText>
                <SecondaryButton
                  style={{ marginTop: 30, clear: 'left', float: 'left' }}
                  value={ text('marketing_footer_lower_button') }
                  onClick={ () => this.props.history.push("/fuer-golfclubs")}
                  autoWidth
                />
              </FooterGolfCourseCTAContent>
            </GridRow>
          </FooterGolfCourseCTA>
        }

        <FooterBottom dark={ isHome }>
          <FooterBottomContent>
            <LogoWrapper>
              <LogoImage src={ Logo } alt="" />
            </LogoWrapper>
            <BottomGrid>
              <div><WhiteTextLink href="/bewerbung">{ text('marketing_footer_link1') }</WhiteTextLink></div>
              <div><WhiteTextLink href="/fuer-golfclubs">{ text('marketing_footer_link2') }</WhiteTextLink></div>
              <div><WhiteTextLink href="/kontakt">{ text('marketing_footer_link3') }</WhiteTextLink></div>
              <div><WhiteTextLink href="/impressum">{ text('marketing_footer_link4') }</WhiteTextLink></div>
              <div><WhiteTextLink href="/datenschutz">{ text('marketing_footer_link5') }</WhiteTextLink></div>
            </BottomGrid>
            <FullWidthWrapper style={{ textAlign: 'center' }}>
              <Text style={{ display: 'inline-block' }} color="#FFFFFF">&copy; { new Date().getFullYear() } { text('all_rights_reserved') }</Text>
            </FullWidthWrapper>
          </FooterBottomContent>
        </FooterBottom>
      </Footer>
    )
  }
}

export default withRouter(MarketingFooter);

const Footer = styled.footer `
  width: 100%;
`

const FooterTop = styled(MaxContentWidthWrapper) `
  background: ${ cssVar.colors.blue };
`

const FooterTopContent = styled(MaxContentWidthContainer) `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 50px;
  padding: 60px 0;

  ${cssVar.breakpoints.phone} {
    grid-template-columns: 1fr;
  }
`

const FooterGolfCourseCTA = styled(FullWidthWrapper) `
  background: ${ cssVar.colors.light_blue };
  height: 300px;
  overflow: hidden;

  ${cssVar.breakpoints.phone} {
    height: auto;
  }
`

const FooterGolfCourseCTAImage = styled.img `
  background: ${ cssVar.colors.light_blue };
  width: 100%;
  height: 300px;
  object-fit: cover;
`

const FooterGolfCourseCTAContent = styled.div `
  margin: auto 0 auto 50px;
  max-width: ${cssVar.max_content_width / 2 - 50}px;

  padding: 30px 50px 30px 0;

  ${cssVar.breakpoints.phone} {
    padding: 60px 30px;
    margin: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
`

const CenteredContentWrapper = styled(FullWidthWrapper) `
  display: flex;
  justify-content: center;
`
const CenteredContent = styled(FullWidthWrapper) `
  display: inline-block;
  width: auto;

  ${cssVar.breakpoints.phone} {
    * {
      text-align: center;
      width: 100%;
    }
  }
`

const FooterBottom = styled(MaxContentWidthWrapper) `
  background: ${ props => props.dark ? cssVar.colors.blue : cssVar.colors.light_blue };

`

const FooterBottomContent = styled(MaxContentWidthContainer) `
  text-align: center;
  padding: 60px 0 30px 0;
`

const LogoWrapper = styled.div `
  ${cssVar.breakpoints.phone} {
    order: 100;
  }
`

const BottomGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 30px;

  > * {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${cssVar.breakpoints.phone} {
    display: flex;
    flex-direction: column;
  }
`

const LogoImage = styled.img `
  width: 100%;
  height: auto;
  max-width: 80px;
  margin-bottom: 30px;
  ${cssVar.breakpoints.phone} {
    padding-top: 30px;
    max-width: 120px;
  }
`

const WhiteTextLink = styled(withColor(TextLink, 'white')) `
  float: left;
  clear: left;

  :hover {
    color: white;
  }
`

const WhiteText = styled(withColor(Text, 'white')) `
  float: left;
  clear: left;
`

const WhiteSectionHeading = styled(withColor(SectionHeading, 'white')) `
  display: inline-block;
  float: left;
  clear: left;
`

const DataPolicyLink = styled.span `
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  transition: all ${ cssVar.transitions.basic };

  :hover {
     color: ${ cssVar.colors.gold };
  }
`



// WEBPACK FOOTER //
// /src/components/layout/MarketingFooter.js